import { identify, isSegmentSendingEvents } from '@mc/track-event'
import { trackEmailCapture, EmailCaptureParams } from '../api/emailCapture'

export const trackEmailCaptured = async (payload: {
  event: string
  properties: EmailCaptureParams
  integrations?: Record<string, boolean>
}) => {
  // If cookies are enabled now: sends an identify immediately
  // If cookies are disabled now: queues an identify that will send if cookies are enabled later
  identify(null, {
    email: payload.properties?.email,
    integrations: { Iterable: true },
  })

  // Check if tracking cookies are enabled
  // If the Segment SDK is enabled and sending events, it implies that the user
  // has consented to some combination of the cookie options we provided
  const isSegmentSendingEventsValue = isSegmentSendingEvents()

  const emailCaptureParams: EmailCaptureParams = {
    email: payload.properties?.email,
    event_name: payload.event,
    page_source: payload.properties?.page_source,
    campaign: payload.properties?.campaign,
    location: payload.properties?.location,
    content_type: payload.properties?.content_type,
    slug: payload.properties?.slug,
    category: payload.properties?.category,
    cookie_consent: isSegmentSendingEventsValue,
    marketing_consent: true,
    product: 'masterclass',
  }

  // Track (and identify) on BE since cookies might be disabled
  await trackEmailCapture(emailCaptureParams)
}
